//PRODUCTS
(function() {

    //Traverse up
    var getClosest = function (elem, selector) {
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;
    };

    //Close container, remove eventListener
    function buttonClick(event) {

        var isClickClose = event.currentTarget.thisClose.contains(event.target);
        var isClickInside = event.currentTarget.thisParent.contains(event.target);

        if(isClickClose || !isClickInside) {
            event.currentTarget.thisParent.classList.remove('open');
            document.removeEventListener('click', buttonClick);
            //Stop click on other article when closing
            event.preventDefault();
        }
     }
    
    //Display modal function
    var displayList = function(target) {

        if(target.classList.contains('wpk-buy-now-button')) {

            //Find out if there are any open Lists
            const openList = document.querySelectorAll('.wp-block-buttons.open');

            //If so, close theme all first
            if(openList.length > 0) {
                openList.forEach((elem) => {
                    elem.classList.remove('open');
                });
            }

            //Find parent
            var parent = getClosest(target, '.wp-block-buttons');

            var closeButton = parent.querySelector('.modal__close');

            //Open container
            parent.classList.add('open');

            //Add listener to whole document. Send container & close parameters to the function
            const documentListener = document;
            documentListener.thisClose = closeButton;
            documentListener.thisParent = parent;
            documentListener.addEventListener('click', buttonClick, false);

        }

    }

    //Buy Now Modal element
    //**************************
    var wpkPostArchiveList = document.getElementById('post-archive-list');
    var wpkProductSingle = document.getElementById('products-single');
    var wpkProductSlider = document.getElementsByClassName('wp-block-wpk-product-list');
    


	if(wpkPostArchiveList) {

        var buyNowArchiveButtons = wpkPostArchiveList.getElementsByClassName('wpk-buy-now-button');

        if(buyNowArchiveButtons.length > 0) {

            wpkPostArchiveList.addEventListener('click', function(event) {

                displayList(event.target);

            }, false);

        }
	} else if(wpkProductSingle) {

        var buyNowSingleButton = wpkProductSingle.getElementsByClassName('wpk-buy-now-button');

        if(buyNowSingleButton.length > 0) {

            wpkProductSingle.addEventListener('click', function(event) {

                displayList(event.target);

            }, false);

        }

    } else if(wpkProductSlider.length > 0) {


        for (var i = 0; i < wpkProductSlider.length; i++) {

            var buyNowSliderButton = wpkProductSlider.item(i).getElementsByClassName('wpk-buy-now-button');

            if(buyNowSliderButton.length > 0) {

                wpkProductSlider.item(i).addEventListener('click', function(event) {
    
                    displayList(event.target);
    
                }, false);
    
            }

         }

    }

})();